// @flow

const ActionReducer = (state: any = [], action: any) => {
    return {
        ...state,
        action: action
    };
};

export default ActionReducer;